import { Typography, Box, Stack, Button, TextField, Grid, Card, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';

import React, { useEffect, useState } from 'react'
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import axios from 'axios';
import { Config, isProduction } from '@/config';
import { useRouter } from 'next/router';
import Cookies from 'universal-cookie';
import { checkLoginStatus } from '@/utils/authen';
import Router from "next/router";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShieldDog } from '@fortawesome/free-solid-svg-icons';
import { log } from 'console';
import { saveRedirectPath } from '@/utils/sessionRedirect';

interface ProductItem {
    item_id: string;
    item_name: string;
    affiliation: string | null;
    coupon: string | null;
    discount: number;
    index: number;
    item_brand: string | null;
    item_category: string | null;
    item_category2: string | null;
    item_category3: string | null;
    item_category4: string | null;
    item_category5: string | null;
    item_list_id: string;
    item_list_name: string;
    item_variant: string | null;
    location_id: string | null;
    price: number;
    quantity: number;
}


export default function CardAddcart({ dataProduct, dataStoreInfo, productOption, optionStork, optionChildValue, optionChild }: any) {
    const router = useRouter();
    const cookies = new Cookies();
    const { isLoggedIn } = checkLoginStatus();
    const token = cookies.get("token");
    const authToken = cookies.get("token");
    const getToken = authToken !== "" ? authToken : null;
    const [count, setCount] = useState(1);
    const [isScrolled, setIsScrolled] = useState(false);
    const [nextFullPath, setNextFullPath] = useState<any>('');
    const [nextAddToCartFullPath, setNextAddToCartFullPath] = useState<any>('');
    const [productIdOption, setProductIdOption] = useState([]);
    const { product_option = [] } = dataProduct?.products ?? {};
    const [open, setOpen] = React.useState(false);
    const [openCart, setOpenCart] = useState(false);
    const [priceProduct, setPriceProduct] = useState<number>(0);
    const [discountPrice, setDiscountPrice] = useState<number>(0);
    const itemList = {
        itemListId: "related_products",
        itemListName: "สินค้า/บริการ ที่เกี่ยวข้อง",
    };

    const handleAddCart = async () => {

        saveRedirectPath();

        if (!isLoggedIn) {
            router.push(`/account/signin`);
            return; 
        }

        

        const storId = dataStoreInfo.store.id;
        const productId = dataProduct.products.product_id;
       
        let optionId: number = 0;

        if (product_option.length == 0) {
            optionId = 0;
        } else if (productOption === null) {
            setOpen(true);
            return false;
        } else if (productOption !== null && optionChild === 0) {
            optionId = productOption;
        } else if (optionChild === null) {
            setOpen(true);
            return false;
        } else {
            optionId = optionChild;
        }

        const quantity = count;

        let data = JSON.stringify({
            store_id: storId,
            product_id: productId,
            option_id: optionId,
            quantity: quantity,
        });


        await axios({
            method: "post",
            url: `${Config.apiEndpoint}cart/add`,
            headers: {
                "accept-language": "th",
                Authorization: "Basic " + Config.encoded,
                "x-access-token": token,
                "Content-Type": "application/json",
            },
            data: data,
        })
            .then((res) => {


                if (res) {
                    updateDataLayer(res.data, itemList);
                    Router.push("/cart");
                }

            })
            .catch((error) => {

                // router.push("/account/signin");
            });
    };

    const handleAddToCart = async () => {
    
        saveRedirectPath();

        if (!isLoggedIn) {
            router.push(`/account/signin`);
            return; 
        }

        const storId = dataStoreInfo.store.id;
        const productId = dataProduct.products.product_id;
        let optionId: number = 0;

        if (product_option.length == 0) {
            optionId = 0;
        } else if (productOption === null) {
            setOpen(true);
            return false;
        } else if (productOption !== null && optionChild === 0) {
            optionId = productOption;
        } else if (optionChild === null) {
            setOpen(true);
            return false;
        } else {
            optionId = optionChild;
        }

        const quantity = count;

        let data = JSON.stringify({
            store_id: storId,
            product_id: productId,
            option_id: optionId,
            quantity: quantity,
        });

        await axios({
            method: "post",
            url: `${Config.apiEndpoint}cart/add`,
            headers: {
                "accept-language": "th",
                Authorization: "Basic " + Config.encoded,
                "x-access-token": getToken,
                "Content-Type": "application/json",
            },

            data: data,
        })
            .then((res) => {
                if (res) {
                    updateDataLayer(res.data, itemList);
                    setOpenCart(true);
                }

            })
            .catch((error) => {
                // console.log(error);
            });
    };


    const handleClose = () => {
        setOpen(false);
        setOpenCart(false);
    };

    const handleCloseCart = () => {
        setOpenCart(false);
        router.reload();
    };

    const handleGoCart = () => {
        setOpenCart(false);
        router.push("/cart");
    };

    useEffect(() => {
        if (count > optionStork && optionStork !== 0) {
            setCount(optionStork);
        }
    }, [optionStork]);

   

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 0) {
                setIsScrolled(true);
            } else {
                setIsScrolled(false);
            }
        };

        window.addEventListener("scroll", handleScroll);

        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const protocol = window.location.protocol;
            const host = window.location.host;
            const fullPath = encodeURIComponent(`${protocol}//${host}${router.asPath}`);
            setNextAddToCartFullPath(fullPath);
            setNextFullPath(fullPath);
        }
    }, [router]);
   

    useEffect(() => {
        if (product_option.length !== 0) {
            setProductIdOption(product_option[0].option_id);
        }
        setPriceProduct(dataProduct?.products.product_normal_price);
        setDiscountPrice(dataProduct?.products.product_discounted_price);
      
    }, [dataProduct]);


    const formatPrice = (price: number, digits: number = 2): number => {
        const formattedPrice = parseFloat(price.toFixed(digits));
        return formattedPrice;
    };

    const updateDataLayer = (data: any, itemList: { itemListId: string; itemListName: string }) => {
        // Check if dataProduct and products are defined
        if (!dataProduct || !dataProduct.products) {
            if (!isProduction) {
                console.warn("No product data available.");
            }
            return;
        }

        const productItem = (() => {
            const { products } = dataProduct;
            const productOptions = Array.isArray(products.product_option)
                ? products.product_option
                : [];

            if (productOptions.length > 0) {
                const filteredData = productOptions.filter((item: any) => {
                    // Check if the item option_id matches or any of the child options' option_id matches
                    const matchesOptionId = item.option_id === data.option_id;
                    const matchesChildOptionId = Array.isArray(item.option_child) 
                        ? item.option_child.some((child: any) => child.option_id === data.option_id)
                        : false;
                
                    return matchesOptionId || matchesChildOptionId;
                });

                const productOption = filteredData.flatMap((opt: any) => {
                    if (Array.isArray(opt.option_child) && opt.option_child.length > 0) {
                        return opt.option_child
                            .filter((child: any) => child.option_id === data.option_id) // กรองเฉพาะ child ที่ตรงกับ data.option_id
                            .map((child: any) => ({
                                discount:
                                    child.option_discount > 0
                                        ? child.option_price - child.option_discount
                                        : 0,
                                price:
                                    child.option_discount > 0
                                        ? child.option_discount
                                        : child.option_price,
                                item_variant: `${opt.option_title} ${opt.option_name} ${child.option_title} ${child.option_name}`,
                            }));
                    } else {
                        return [
                            {
                                discount:
                                    opt.option_discount > 0
                                        ? opt.option_price - opt.option_discount
                                        : 0,
                                price:
                                    opt.option_discount > 0
                                        ? opt.option_discount
                                        : opt.option_price,
                                item_variant: `${opt.option_title} ${opt.option_name}`,
                            },
                        ];
                    }
                });

                // Map product options to items
                return productOption.map((option: any) => {
                    const item = {
                        item_id: products.product_id || null,
                        item_name: products.product_title || null,
                        affiliation: null,
                        coupon: null,
                        discount: formatPrice(option.discount) || 0,
                        index: 0,
                        item_brand: null,
                        item_category: null,
                        item_category2: null,
                        item_list_id: itemList.itemListId,
                        item_list_name: itemList.itemListName,
                        item_variant: option.item_variant || null,
                        location_id: null,
                        price: formatPrice(option.price) || 0,
                        quantity: data.quantity || 1, // Default quantity to 1 if not provided
                    };

                    // ใช้ Object.entries() และกรองคีย์ที่ค่าไม่เป็น null
                    return Object.fromEntries(
                        Object.entries(item).filter(([_, value]) => value !== null)
                    );
                });
            } else {
                // Return default item structure if no options available
                const isDiscounted = products.product_discounted_price > 0;
                const price = isDiscounted ? products.product_discounted_price : products.product_normal_price;
                const discount = isDiscounted ? products.product_normal_price - products.product_discounted_price : 0;

                return [
                    Object.fromEntries(
                        Object.entries({
                            item_id: products.product_id || null,
                            item_name: products.product_title || null,
                            affiliation: null,
                            coupon: null,
                            discount: formatPrice(discount) || 0,
                            index: 0,
                            item_brand: null,
                            item_category: null,
                            item_category2: null,
                            item_list_id: itemList.itemListId,
                            item_list_name: itemList.itemListName,
                            item_variant: null,
                            location_id: null,
                            price: formatPrice(price) || 0,
                            quantity: data.quantity || 1, // Default quantity to 1 if not provided
                        }).filter(([_, value]) => value !== null) // กรองฟิลด์ที่มีค่าเป็น null ออก
                    ),
                ];
            }
        })();

        // Calculate total value
        const totalValue = productItem.reduce((acc: number, item: any) => {
            const itemPrice = item.price || 0;
            const itemQuantity = item.quantity || 0;
            return acc + itemPrice * itemQuantity;
        }, 0);

        // Update the DataLayer
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ ecommerce: null }); // Clear previous ecommerce data
        window.dataLayer.push({
            event: "add_to_cart",
            ecommerce: {
                currency: "THB",
                value: formatPrice(totalValue),
                items: productItem,
            },
        });

        if (!isProduction) {
            console.log("DataLayer updated:", {
                event: "add_to_cart",
                ecommerce: {
                    currency: "THB",
                    value: formatPrice(totalValue),
                    items: productItem,
                },
            });
        }
    };


    return (
        <Grid item xs={12} sm={12} md={12} lg={12}>
        
            <Card
                className={`floating-element ${isScrolled ? "scrolled" : ""}`}
                sx={{ boxShadow: 'none', border: "1px solid rgba(224, 224, 224, 1)",zIndex:0, height: "auto" }}
            >
                <Box
                    sx={{
                        m: "12px"
                    }}
                >
                    <Typography
                        sx={{
                            fontSize: "18px",
                            fontFamily: ' NotoSansThai-SemiBold'
                        }}
                    >
                        จำนวน

                    </Typography>

                    <Stack direction="row" spacing={2}
                        sx={{
                            pt: "5px",
                            width: "100%"

                        }}
                    >
                        <Button
                            variant="outlined"
                            sx={{ width: "24px", height: "24px", padding: "0px", minWidth: "24px", borderRadius: "4px" }}
                            value="add"
                            onClick={() => {
                                setCount(Math.max(count - 1, 1));
                            }}
                            disabled={count === 1}
                        >
                            <RemoveIcon
                                style={{
                                    fontSize: "16px",
                                    height: "auto",
                                    padding: "0px",
                                }}
                            />
                        </Button>


                        <Typography
                            sx={{
                                fontSize: "14px",
                                alignItems: "end",
                                justifyContent: "end"

                            }}
                        >
                            {
                                dataProduct?.products.product_quantity === 0 &&
                                    dataProduct?.products.product_stock === "0"
                                    ? "0"
                                    : count
                            }
                        </Typography>
                        <Button
                            sx={{ width: "24px", height: "24px", padding: "0px", minWidth: "24px", borderRadius: "4px" }}
                            variant="outlined"
                            value="delete"
                            onClick={() => {
                                setCount(Math.min(count + 1, optionStork));
                            }}
                            disabled={count === optionStork}
                        >
                            <AddIcon fontSize="small"
                                style={{
                                    fontSize: "16px",
                                    height: "auto",
                                    padding: "0px",
                                }} />
                        </Button>
                        <Typography
                            variant="body2"
                            color="text.secondary"
                            display="flex"
                            alignItems="end"
                            sx={{ fontSize: "12px", pt: "5px", flexGrow: 1, justifyContent: "flex-end" }}
                        >
                            {dataProduct?.products.product_quantity === 0 &&
                                dataProduct?.products.product_stock === "0"
                                ? "สินค้าหมด"
                                : "มีสินค้าทั้งหมด " + optionStork + " รายการ"}
                        </Typography>



                    </Stack>

                    <Button
                     
                        onClick={handleAddCart}
                        disabled={optionStork == 0 ? true : false}
                        className={
                            optionStork == 0 ? "btn-disabled" : "btn-20"
                        }
                        sx={{
                            width: "100%",
                            mt: "12px",
                            minHeight: "37px"
                        }}
                    >
                        <Typography
                            sx={{  fontSize: "15px", color: "#FFFFFF !important" }}
                        >
                            ซื้อสินค้า
                        </Typography>
                    </Button>
                    <Button
                      
                        onClick={handleAddToCart}
                        disabled={optionStork == 0 ? true : false}
                        className={
                            optionStork == 0 ? "btn-disabled" : "btn-10"
                        }
                        sx={{
                            width: "100%",
                            mt: "12px",
                            minHeight: "37px"
                        }}
                    >

                        <Typography sx={{ fontSize: "15px" }}>
                            เพิ่มไปยังรถเข็น
                        </Typography>
                    </Button>
                    <Stack direction={"row"}
                        sx={{
                            mt: "15px",
                        }}
                    >
                        <FontAwesomeIcon icon={faShieldDog} />
                        <Typography
                            sx={{
                                fontSize: "12px",
                                fontFamily: ' NotoSansThai-SemiBold',
                                ml: "2px"
                            }}
                        >
                            ความปลอดภัย & ความเป็นส่วนตัว
                        </Typography>

                    </Stack>
                    <Typography
                        sx={{
                            fontSize: "10px",
                            color: "#717275"
                        }}
                    >
                        เราไม่เปิดเผยรายละเอียดส่วนตัวของคุณกับบุคคลภายนอกโดยไม่ได้รับความยินยอมจากคุณ
                        รักษาความปลอดภัยให้กับรายละเอียดส่วนบุคคล
                    </Typography>

                </Box>

            </Card>

            <Dialog
                open={open}
              
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle
                    className="fontSize-20 txt-bold"
                    sx={{ textAlign: "center", mt: "30px" }}
                    id="alert-dialog-title"
                >
                    {"รถเข็น"}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText
                        sx={{ px: { xs: "20px", md: "50px" } }}
                        id="alert-dialog-description"
                    >
                        กรุณาเลือกตัวเลือกของสินค้าก่อน
                    </DialogContentText>
                </DialogContent>
                <DialogActions sx={{ justifyContent: "center", mb: "30px" }}>
                    <Button
                        onClick={handleClose}
                        autoFocus
                        className="btn-20"
                        sx={{ padding: "10px 60px", margin: "0 !important" }}
                    >
                        ตกลง
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={openCart}
               
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                fullWidth={true}
            >
                <DialogTitle
                    className="fontSize-20 txt-bold"
                    sx={{ textAlign: "center", mt: "30px" }}
                    id="alert-dialog-title"
                >
                    {"รถเข็น"}
                </DialogTitle>
                <DialogContent sx={{ textAlign: "center" }}>
                    <DialogContentText id="alert-dialog-description">
                        เพิ่มสินค้าไปยังรถเข็นของคุณแล้ว
                    </DialogContentText>
                </DialogContent>
                <DialogActions
                    sx={{
                        flexDirection: { xs: "column", md: "row" ,sm:"row" },
                        justifyContent: "center",
                        gap: "15px",
                        mb: "30px",
                    }}
                >
                    <Button
                        className="btn-cancle"
                        onClick={handleCloseCart}
                    >
                        ซื้อสินค้าต่อ
                    </Button>
                    <Button
                        className="btn-success" 
                        onClick={handleGoCart}
                        autoFocus
                    >
                        ไปยังรถเข็น
                    </Button>
                </DialogActions>
            </Dialog>
        </Grid>
    )
}